/** API route map: URLS.Controller.ClientTask */
export const ClientTask = {
      Name: 'ClientTask/',
      GetAllTask: 'client-task',
      GetAllByGuestTask: 'get-all-by-guest-task',
      AddTask: 'add',
      UpdateTask: 'update',
      DeleteTask: 'delete',
      PatchTaskStatus: 'patch-task-status',
};
